import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import appReducer from './ducks'
import { AnyAction, configureStore } from '@reduxjs/toolkit'
import listenerMiddleware from '@/redux/listenerMiddleware'

const rootReducer = (state, action) => {
  if (action.type === 'orgamax/global/USER_LOGOUT') {
    state = undefined
  }
  try {
    return appReducer(state, action)
  } catch (ex) {
    console.error(ex)
  }

  return appReducer(state, {} as AnyAction)
}

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  devTools: ENV.build !== 'production',
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
      .prepend(listenerMiddleware.middleware)
  },
})

export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type DispatchFunc = () => AppDispatch
export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const getAppState = () => store.getState() as RootState
export const dispatch = store.dispatch

export const appState = {
  ...store,
  getState: getAppState,
}

// there are errors in Storybook if the default export is not created last
export default store
